// Shared compact-mode coordination for FilterControls and SortControl. When a
// component is rendered standalone (no provider), the fallback returns
// non-compact defaults so the full UI always renders.

import { createContext, useContext } from 'react';

export type CollectionToolbarSide = 'filters' | 'sort';

export type CollectionToolbarContextValue = {
  isCompact: boolean;
  expanded: CollectionToolbarSide | null;
  setExpanded: (side: CollectionToolbarSide | null) => void;
};

const FALLBACK: CollectionToolbarContextValue = {
  isCompact: false,
  expanded: null,
  setExpanded: () => {},
};

export const CollectionToolbarContext =
  createContext<CollectionToolbarContextValue | null>(null);

export const useCollectionToolbarContext = (): CollectionToolbarContextValue =>
  useContext(CollectionToolbarContext) ?? FALLBACK;
